<template>
	<div class="page-wrap">
		<!-- 顶部操作栏 -->
		<div class="toolbar">
			<el-button type="primary" icon="el-icon-plus" @click="handleAdd">新增</el-button>
		</div>

		<!-- 表格列表 -->
		<el-table :data="tableData" border stripe style="margin-top:12px;width:100%">
			<el-table-column label="序号" width="60" align="center">
				<template slot-scope="{ $index }">
					{{ (page - 1) * pageSize + $index + 1 }}
				</template>
			</el-table-column>
			<el-table-column prop="name" label="名称" />
			<el-table-column prop="status" label="状态">
				<template slot-scope="scope">
					{{scope.row.status==0?'未发布':scope.row.status==1?"已发布":"已下架"}}
				</template>
			</el-table-column>
			<el-table-column prop="publishTime" label="发布时间">
				<template slot-scope="scope">
					{{formTime(scope.row.publishTime)||'--'}}
				</template>
			</el-table-column>
			<el-table-column label="操作" width="180" align="center">
				<template slot-scope="scope">
					<el-button type="text" size="small" @click="getNoticeDocContent(scope.row)" v-if="scope.row.status!=2">编辑</el-button>
					<el-button type="text" size="small" style="color:#f56c6c"
					v-if="scope.row.status!=2"	@click="handleDel(scope.row)">删除</el-button>
				</template>
			</el-table-column>
		</el-table>

		<!-- 分页 -->
		<el-pagination style="margin-top:16px;text-align:right" :current-page="page" :page-size="pageSize"
			:total="total" layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
			@current-change="handlePageChange" />

		<!-- 弹窗：不要直接在el-dialog写height -->
		<el-dialog :title="currentRow.title" :visible.sync="isFaq" width="80%" @close="onDialogClose" style="overflow-y: hidden;">
			<el-form :model="currentRow" label-width="100px">
				<el-form-item label="名称">
					<el-input v-model="currentRow.name" placeholder="请输入名称"></el-input>
				</el-form-item>
				<el-form-item label="发布时间">
					<el-date-picker v-model="currentRow.publishTime" type="date" placeholder="请选择发布时间"
						value-format="yyyy-MM-dd HH:mm:ss" style="width:100%"
						:picker-options="pickerOptions"></el-date-picker>
				</el-form-item>
				<!-- 固定高度容器给CKEditor做父级 -->
				<el-form-item label="内容">
					<div class="dialog-editor-wrap">
						<CkEditor :value="text" v-if="isFaq" ref="editorComponent"
							@onaltchange="handleEditorAltChange" />
					</div>
				</el-form-item>
			</el-form>

			<div slot="footer" class="dialog-footer">
				<el-button @click="isFaq = false">取消</el-button>
				<el-button type="success" @click="handleSave">{{isEdit?'修改':'新增'}}</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import CkEditor from "@/components/QuillEditor/CkEditor.vue";
	const OSS_DOMAIN = "http://schoolclsaaroom.oss-cn-beijing.aliyuncs.com/";

	export default {
		name: "TableAddPage",
		components: {
			CkEditor,
		},
		data() {
			return {
				// 分页参数
				page: 1,
				pageSize: 10,
				total: 0,
				isFaq: false,
				currentRow: {
					id: null,
					title: "新增",
					name: "",
					publishTime: ""
				},
				// 表格数据
				tableData: [],
				text: '',
				docType: "FAQ",
				login: null,
				isEdit: false, // 标记是否编辑模式
				pickerOptions: {
					disabledDate: (time) => {
						// 编辑模式：不做任何禁用，历史时间可选
						if (this.isEdit) {
							return false;
						}
						// 新增模式：禁止今天之前
						return time.getTime() < Date.now() - 8.64e7;
					}
				},
			};
		},
		mounted() {
			this.fetchList();
		},
		methods: {
			formTime(val) {
				var name = ''
				if (val) {
					let date = new Date(val)
					let y = date.getFullYear()
					let m = (date.getMonth() + 1 + '').padStart(2, '0')
					let d = (date.getDate() + '').padStart(2, '0')
					let hh = (date.getHours() + '').padStart(2, '0')
					let mm = (date.getMinutes() + '').padStart(2, '0')
					name = `${y}-${m}-${d} ${hh}:${mm}`
				}
				return name
			},
			handleEditorAltChange() {

			},
			// 获取列表
			async fetchList() {

				try {
					let res = await this.API.get(this.API.fileurl.getNoticeDocAdminPage, {
						pageNum: this.page,
						pageSize: this.pageSize,
						docType: this.docType,
						// status:this.status.
					})
					console.log('rrr', res.data)
					this.tableData = res.data.data.records || [];
					this.total = res.data.data.total;
				} catch (e) {
					this.$message.error("查询列表失败");
				}
			},
			async getNoticeDocContent(val) {
				  this.isEdit = true;
				  let timeStr = null;
				  if(val.publishTime) {
				    // val.publishTime 是时间戳 number
				    const date = new Date(val.publishTime);
				    const y = date.getFullYear();
				    const m = String(date.getMonth() +1).padStart(2,'0');
				    const d = String(date.getDate()).padStart(2,'0');
				    // type="date" 选择器，时分固定00:00:00，和value-format匹配
				    timeStr = `${y}-${m}-${d} 00:00:00`;
				  }
				
				  this.currentRow = {
				    id: val.id,
				    title: '修改FAQ',
				    name: val.name,
				    publishTime: timeStr
				  };
				try {
					let res = await this.API.get(this.API.fileurl.getNoticeDocContent + val.id)

					let content = res.data.data

					if (!content) return ''

					// 1. 创建虚拟DOM解析html字符串
					const parser = new DOMParser()
					const doc = parser.parseFromString(content, 'text/html')
					const imgList = Array.from(doc.querySelectorAll('img'))

					// 2. 循环所有img，收集异步签名任务
					const promiseTasks = imgList.map(async imgEl => {
						const originalSrc = imgEl.getAttribute('src')
						if (!originalSrc) return
						// 只处理oss相对路径（排除http开头已经是外网地址）
						if (originalSrc.startsWith('http')) return

						// await 获取oss签名下载url
						const signUrl = await this.$oss.getDownloadUrl(originalSrc)
						imgEl.setAttribute('src', signUrl)
					})

					// 等待全部图片签名完成
					await Promise.all(promiseTasks)

					// 获取处理之后完整html
					const handledHtml = doc.body.innerHTML


					// 这里handledHtml就是全部图片src已经替换成签名url的html，赋值给编辑器
					this.text = handledHtml
					this.isFaq = true
					// if (this.$refs.editorComponent) {
					// 	this.$refs.editorComponent.refreshEditor();
					// }
				} catch (e) {
					console.error('获取文档内容处理图片失败', e)
				} finally {

				}
			},
			onDialogClose() {
				this.isEdit=false
				//关闭弹窗清空内容
				this.text = '';
				this.currentRow = {
					id: null,
					title: "新增",
					name: "",
					publishTime: null,
				};
			},
			// 新增
			handleAdd() {
				this.isEdit=false
				this.text = '';
				this.currentRow = {
						id: null,
						title: '新增FAQ',
						name: "",
						publishTime: ''
					},
					this.isFaq = true
			},

			// 编辑
			handleEdit(row) {
				this.currentRow = row;
				this.isFaq = true;
			},
			cleanOssUrl(fullUrl) {
				if (!fullUrl) return '';
				let path = fullUrl.replace(OSS_DOMAIN, "");
				const qIndex = path.indexOf('?');
				if (qIndex !== -1) {
					path = path.substring(0, qIndex);
				}
				
				return path;
			},
			async handleSave() {
				
				  const row = { ...this.currentRow };
				  // 字符串日期转时间戳；为空保持null
				  if (row.publishTime) {
				    // 转毫秒时间戳
				    row.publishTime = new Date(row.publishTime).getTime();
				  } 
				
				const originHtml = this.$refs.editorComponent.getEditorData();
				if (!originHtml) {
					this.$message.warning("内容不能为空");
					return;
				}

				try {
					this.loginOpen('信息处理中...')
					const publishTime = row?.publishTime || Date.now();
					const docType = this.docType;
					row.publishTime=publishTime
					const allImgRegex = /<img[^>]*src=["']([^"']+)["'][^>]*>/g;
					let match;
					const base64TaskList = [];
					const httpImgItems = []; // {oldTag, fullSrc, cleanSrc}

					while ((match = allImgRegex.exec(originHtml)) !== null) {
						const fullImgTag = match[0];
						const src = match[1];

						if (src.startsWith('data:image')) {
							base64TaskList.push({
								oldTag: fullImgTag,
								base64: src
							})
						} else if (src.startsWith('http://') || src.startsWith('https://')) {
							const cleanSrc = this.cleanOssUrl(src);
							httpImgItems.push({
								oldTag: fullImgTag,
								fullSrc: src,
								cleanSrc: cleanSrc
							})
						}
					}

					// --------第一步：先把HTML中原有的http图片直接替换成相对路径--------
					let workingHtml = originHtml;
					const httpImageSrcList = [];
					for (const item of httpImgItems) {
						workingHtml = workingHtml.replace(item.oldTag, item.oldTag.replace(item.fullSrc, item
							.cleanSrc));
						httpImageSrcList.push(item.cleanSrc);
					}

					// 没有base64图片，直接提交（已经替换完http图片）
					if (base64TaskList.length === 0) {
						this.submitFinalHtml(row, docType, workingHtml, httpImageSrcList);
						return;
					}
					this.login.text = `正在上传图片...`
					const ossData = await this.getImgToOss("faq");
					if (!ossData) {
						this.$message.closeAll();
						this.$message.error("获取OSS上传凭证失败");
						return;
					}

					const promiseList = base64TaskList.map(async (item, i) => {
						const blob = this.dataURLtoBlob(item.base64);
						const fileName =
							`faq_img_${Date.now()}_${Math.random().toString(36).slice(2)}.png`;
						const fullOssUrl = await this.mockUpload(blob, fileName, ossData, i);
						const cleanRelativeUrl = this.cleanOssUrl(fullOssUrl);
						return {
							oldTag: item.oldTag,
							cleanRelativeUrl
						}
					})

					Promise.all(promiseList).then(resList => {
						// 第二步：把base64图片替换成【相对路径】
						for (const r of resList) {
							workingHtml = workingHtml.replace(r.oldTag, r.oldTag.replace(r.oldTag.match(
								/src=["'](.*?)["']/)[1], r.cleanRelativeUrl));
						}
						this.$message.closeAll();

						const newUploadOssUrlList = resList.map(i => i.cleanRelativeUrl);
						const totalImageUrlList = [...httpImageSrcList, ...newUploadOssUrlList];

						this.submitFinalHtml(row, docType, workingHtml, totalImageUrlList);
					}).catch(err => {
						this.$message.closeAll();
						this.$message.error("图片上传失败");
						console.error(err);
					})


				} catch (e) {

				} finally {
					this.noLogin()
				}
			},
			// 加载
			loginOpen(text) {
				this.login = this.$loading({
					lock: true,
					text,
					zIndex: 100001,
					spinner: 'el-icon-loading',
					background: 'rgba(0,0,0,0.7)'
				});
			},
			noLogin() {
				if (this.login) {
					this.login.close();
					this.login = null;
				}
			},
			// 提交最终处理完成html
			async submitFinalHtml(row, docType, finalHtml, imageUrlList) {
				console.log("处理完成后的html：", finalHtml);
				console.log('imageUrlList', imageUrlList)
				console.log('publishTime',row.publishTime)
				
				const reqBody = {
					id: row?.id || null,
					docType: docType,
					content: finalHtml,
					publishTime: row.publishTime,
					status: row?.status || 0,
					imageUrlList: imageUrlList || [],
					userId: localStorage.getItem("userId")
				};
				
				
				try {
					let res={}
					if(!this.isEdit){
						res = await this.API.post(this.API.fileurl.postNoticeDocSave, reqBody)
					}else{
						res=await this.API.post(this.API.fileurl.postNoticeDocUpdate, reqBody)
					}
					
					this.isFaq = false;
					this.fetchList();
				} catch (e) {

				} finally {

				}
			},

			// base64 转 Blob二进制对象
			dataURLtoBlob(dataurl) {
				let arr = dataurl.split(',');
				let mime = arr[0].match(/:(.*?);/)[1];
				let bstr = atob(arr[1]);
				let n = bstr.length;
				let u8arr = new Uint8Array(n);
				while (n--) {
					u8arr[n] = bstr.charCodeAt(n);
				}
				return new Blob([u8arr], {
					type: mime
				});
			},

			async getImgToOss(type) {
				try {
					let res = await this.API.get(this.API.fileurl.getImgToOss, {
						type: type
					})
					return res.data
				} catch (e) {
					console.error(e);
					return null;
				}
			},
			async mockUpload(file, fileName, ossData, index) {
				console.log(file, fileName, ossData, index)
				if (!file || !ossData) throw new Error('file / ossData 不能为空')
				if (!ossData.host || !ossData.dir || !ossData.uuid) throw new Error('OSS 参数缺失')

				const host = ossData.host.replace(/\/$/, '')
				const dir = ossData.dir.replace(/^\//, '').replace(/\/$/, '') + '/'
				const ext = fileName.split('.').pop().toLowerCase() || 'png'
				index = index.toString()
				if (index.length == 1) {
					index = `00${Number(index)+1}`
				} else if (index.length == 2) {
					index = `0${Number(index)+1}`
				}
				const key = `${dir}${ossData.uuid}${index}.${ext}`
				console.log('key', key)
				const formData = new FormData()
				formData.append('key', key)
				formData.append('OSSAccessKeyId', ossData.accessKeyId)
				formData.append('policy', ossData.policy)
				formData.append('signature', ossData.signature)
				formData.append('file', file)

				try {
					const controller = new AbortController()
					const timer = setTimeout(() => controller.abort(), 30000)
					const res = await fetch(host, {
						method: 'POST',
						body: formData,
						signal: controller.signal
					})
					clearTimeout(timer)
					if (res.status === 200 || res.status === 204) {
						// 返回完整的http url
						const fullUrl = `${ossData.dir}${ossData.uuid}${index}.${ext}`;
						return fullUrl;
					}
					const errMsg = await res.text()
					console.error('❌ OSS 报错：', res.status, errMsg)
					throw new Error(`上传失败 ${res.status}`)
				} catch (err) {
					console.error('❌ 上传异常：', err)
					const msg = err.name === 'AbortError' ? '上传超时' : err.message
					throw new Error('上传失败：' + msg)
				}
			},

			// 删除
			handleDel(row) {
				this.$confirm("确定要删除该条数据吗？", "提示", {
					confirmButtonText: "确定",
					cancelButtonText: "取消",
					type: "warning"
				}).then(async () => {
					let res=await this.API.post(this.API.fileurl.postNoticeDocStatus,{
						status:2,
						userId:localStorage.getItem('userId'),
						id:row.id
					})
					this.$message.success("删除成功");
					this.fetchList();
				}).catch(() => {});
			},

			// 每页条数改变
			handleSizeChange(val) {
				this.pageSize = val;
				this.page = 1;
				this.fetchList();
			},

			// 页码改变
			handlePageChange(val) {
				this.page = val;
				this.fetchList();
			}
		}
	};
</script>

<style scoped>
	.page-wrap {
		padding: 16px;
	}

	.toolbar {
		display: flex;
		justify-content: flex-start;
	}

	/* dialog内部容器给确定高度 */
	.dialog-editor-wrap {
		height: 60vh;
	}

	.dialog-footer {
		text-align: right;
		margin-top: 12px;
	}
</style>